// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container for the PDF viewer */
.pdf-container {
  height: calc(100vh - 120px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

/* Center each page */
.page-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  clear: both;              /* FIXES FLOATING ISSUES */
}

/* PDF page style */
.page-wrapper canvas {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
}

/* ✔ THIN BLACK SEPARATOR BETWEEN PAGES */
.page-separator {
  width: 80%;
  height: 2px;
  background: black;
  margin: 20px auto;         /* Center it */
  display: block;            /* FIX */
  clear: both;               /* FIX */
}

.field-box {
  position: absolute;
  cursor: grab;
  z-index: 10;
}

.field-box.dragging { /* While dragging */
  opacity: 0.7;
  z-index: 9999;  /* ON DRAG */
}

.field-box.released { /* After drag release */
  position: static !important;
  z-index: 0 !important;
  transform: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/css/ContractEditor.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,WAAW,eAAe,0BAA0B;AACtD;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA,yCAAyC;AACzC;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,iBAAiB,UAAU,cAAc;EACzC,cAAc,aAAa,QAAQ;EACnC,WAAW,gBAAgB,QAAQ;AACrC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA,sBAAsB,mBAAmB;EACvC,YAAY;EACZ,aAAa,GAAG,YAAY;AAC9B;;AAEA,sBAAsB,uBAAuB;EAC3C,2BAA2B;EAC3B,qBAAqB;EACrB,0BAA0B;AAC5B","sourcesContent":["/* Container for the PDF viewer */\n.pdf-container {\n  height: calc(100vh - 120px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 10px;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Center each page */\n.page-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  clear: both;              /* FIXES FLOATING ISSUES */\n}\n\n/* PDF page style */\n.page-wrapper canvas {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.15);\n}\n\n/* ✔ THIN BLACK SEPARATOR BETWEEN PAGES */\n.page-separator {\n  width: 80%;\n  height: 2px;\n  background: black;\n  margin: 20px auto;         /* Center it */\n  display: block;            /* FIX */\n  clear: both;               /* FIX */\n}\n\n.field-box {\n  position: absolute;\n  cursor: grab;\n  z-index: 10;\n}\n\n.field-box.dragging { /* While dragging */\n  opacity: 0.7;\n  z-index: 9999;  /* ON DRAG */\n}\n\n.field-box.released { /* After drag release */\n  position: static !important;\n  z-index: 0 !important;\n  transform: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
